// Module
var code = `<div class="jumbotron-surface about-surface">
  <div class="jumbotron-panel-head">
    <span class="jumbotron-heading">About</span>
  </div>

  <div class="about-body">
    <div class="about-app">
      <span class="jumbotron-title about-name">JumboTRON</span>
      <span class="jumbotron-subtitle">{{ \$ctrl.version | jumbotronVersion }}</span>
    </div>

    <div class="about-field">
      <span class="jumbotron-kind-label">This page opened</span>
      <span class="about-value">{{ \$ctrl.currentDateTime }}</span>
    </div>
  </div>
</div>
`;
// Exports
export default code;